export default __webpack_public_path__ + "images/gestational_diabetes_blue.2d870a329d7490f2eea80ae258f52175.png";